export const PART_PARTS = [
  'container',
  'thumbnailContainer',
  'labelContainer',
  'label',
  'labelPrefix',
  'labelPlaceholder',
  'secondaryLabel',
  'badgeContainer',
] as const;
